var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 10.5L14.25 9M14.25 9L15.75 7.5M14.25 9L12.75 7.5M14.25 9L15.75 10.5",
    stroke: "#E8E8E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 10.5V7.49999C2.25 7.30108 2.32902 7.11031 2.46967 6.96966C2.61032 6.82901 2.80109 6.74999 3 6.74999H5.02275C5.1709 6.75003 5.31574 6.70618 5.439 6.62399L8.58375 4.52699C8.69681 4.45156 8.82823 4.40827 8.96399 4.40174C9.09974 4.39522 9.23472 4.4257 9.35449 4.48994C9.47426 4.55418 9.57432 4.64975 9.64398 4.76645C9.71365 4.88315 9.75029 5.01658 9.75 5.15249V12.8475C9.75002 12.9833 9.71318 13.1165 9.64341 13.233C9.57363 13.3495 9.47355 13.4448 9.35382 13.5089C9.2341 13.573 9.09924 13.6033 8.96361 13.5967C8.82799 13.5901 8.6967 13.5469 8.58375 13.4715L5.439 11.3752C5.31566 11.2933 5.17082 11.2497 5.02275 11.25H3C2.80109 11.25 2.61032 11.171 2.46967 11.0303C2.32902 10.8897 2.25 10.6989 2.25 10.5Z",
    stroke: "#E8E8E8",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOff);
export default __webpack_public_path__ + "static/media/off.2d94767dcf7bd9bffbc395ccd9a426d2.svg";
export { ForwardRef as ReactComponent };